import { render } from "./PlanszaPoziomow.vue?vue&type=template&id=abbd5ae6&scoped=true"
import script from "./PlanszaPoziomow.vue?vue&type=script&lang=js"
export * from "./PlanszaPoziomow.vue?vue&type=script&lang=js"

import "./PlanszaPoziomow.vue?vue&type=style&index=0&id=abbd5ae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abbd5ae6"]])

export default __exports__